(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cd-collection-intro"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{document.querySelectorAll('.cd-category-picker[open]').forEach(picker=>{if(!picker.contains(event.target))picker.open=false})});
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.cd-category-picker[open]').forEach(picker=>{picker.open=false;picker.querySelector('summary').focus()})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cd-header"]) return;
  try {
    
document.addEventListener('keydown',event=>{if(event.key==='Escape'){document.querySelectorAll('.cd-mobile-menu[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus()})}});
document.addEventListener('click',event=>{document.querySelectorAll('.cd-mobile-menu[open]').forEach(menu=>{if(!menu.contains(event.target)||event.target.closest('a'))menu.open=false})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cd-quote"] && !Shopify.designMode) return;
  try {
    
function setupStudioQuote(){const type=document.querySelector('[data-cd-project]');const message=document.querySelector('[data-cd-message]');if(!type||type.dataset.ready)return;type.dataset.ready='true';const project=new URLSearchParams(window.location.search).get('project');if(!project)return;const value=project.toLowerCase();type.value=value.includes('dtf')?'DTF transfers':value.includes('team')?'Team or group order':'Custom apparel';if(message&&!message.value)message.value=project==='dtf'?'':'Project: '+project;}
setupStudioQuote();
document.addEventListener('shopify:section:load',setupStudioQuote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
